import * as React from "react";
import { createContainer } from "./StateContainer";

const useDraggableAircraftContainerState = () => {
  const [placementIdBeingDragged, setPlacementIdBeingDragged] = React.useState<
    string
  >("");
  return {
    isTugging: (id: string) => id === placementIdBeingDragged,
    setIsTugging: (id: string) => setPlacementIdBeingDragged(id),
  };
};
const DraggableAircraftContainerState = createContainer(
  useDraggableAircraftContainerState
);

export const DraggableAircraftContainer: React.FC<{
  children?: React.ReactNode;
}> = ({ children }) => {
  return (
    <DraggableAircraftContainerState.Provider>
      {children}
    </DraggableAircraftContainerState.Provider>
  );
};

/**
 * Hook into the current identity context.
 */
export const useDraggableAircraft =
  DraggableAircraftContainerState.useContainer;
